  <script>
	export default {
		data() {
				return {
				  user_permission:{
                        data: {
                        	campaign_view: '',
                        	campaign_create: '',
                        	campaign_schedule: '',
                        	announcement_view: '',
                        	announcement_create: '',
                        	view_recepients: '',
                        	add_new_recepients: '',
                        	view_report: '',
                        	add_new_report: '',
                        	domain: '',
                        	general: '',
                        	user_management: '',
                        	retest_frequency: '',
                        	direct_learning_management: '',
                        	direct_learning_invitation_mail: '',
                        	direct_learning_login_mail: '',
                        	direct_learning_with_username_and_password_mail: '',
                        	landing_oops: '',
                        	training_mail: '',
                        	email_setting: '',
                        	company_logo: {
                        		logo: '',
                        	}
                        },
                    },
	 	}
	},
 }
</script>
<template>
   <!-- side nav bar -->
  <nav class="page-sidebar" data-pages="sidebar">
    <div class="sidebar-header">
      <img src="/static/img/logo-white.svg" alt="logo" class="brand" data-src="/static/img/logo-white.svg" data-src-retina="/static/img/logo-white.svg" width='180'>
      <div class="sidebar-header-controls"></div>
    </div>
     <div class="sidebar-menu">
        <ul class="menu-items">
           <li class="open active m-t-30">
              <a href="javascript:;"><span class="title">LMS</span>
              <span class=" open  arrow"></span></a>
              <span class="icon-thumbnail"><i class="fas fa-book-reader custom_reader"></i></span>
              <ul class="sub-menu">
                 <li class="">
                     <router-link :to="{ name: 'lms.courses2'}">Courses</router-link>
                     <span class="icon-thumbnail"><i class="fas fa-book"></i></span>
                 </li>
                 <li class="">
                  <router-link :to="{ name: 'lms.reports'}">Reports</router-link>
                  <span class="icon-thumbnail"><i class="fas fa-file-alt"></i></span>
                 </li>
                 <li class="">
                  <router-link :to="{ name: 'lms.setting'}">Settings</router-link>
                   <span class="icon-thumbnail"><i class="fas fa-cog"></i></span>
                 </li>
                 <li class="">
                  <router-link :to="{ name: 'lms.emaillogs'}">Sent mails</router-link>
                      <span class="icon-thumbnail"><i class="far fa-envelope"></i></span>
                 </li>

              </ul>
           </li>
        </ul>
     </div>
  </nav>
</template>





// WEBPACK FOOTER //
// sidebar.vue?5514e66a